import {Component, computed, effect, inject, OnInit, Signal} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {ActivatedRoute, Router} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {ClpFormatPipe} from '@shared/pipes/clp/clp-format-pipe';
import {MatDialogModule} from '@angular/material/dialog';
import {Category, FoodItem} from '@core/models';
import {TruncatePipe} from '@shared/pipes/truncate/truncate-pipe';
import {BgUrlPipe} from '@shared/pipes/bg-url/bg-url-pipe';
import {NgStyle} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CatalogStore} from '@store/catalog.store';
import {SessionStore} from '@store/session.store';
import {CartStore} from '@store/cart.store';

@Component({
  selector: 'app-menu',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    ClpFormatPipe,
    MatDialogModule,
    TruncatePipe,
    BgUrlPipe,
    NgStyle
  ],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu implements OnInit {

  private readonly snackBar = inject(MatSnackBar);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private readonly store = inject(CatalogStore);
  protected readonly products: Signal<FoodItem[]> = this.store.products;
  public categories: Signal<Category[]> = computed(() => {
    const all = this.store.categories();
    const currentId = this.selectedCategoryId();

    if (!currentId) return all;

    const selected = all.filter(c => c.categoryId === currentId);
    const others = all.filter(c => c.categoryId !== currentId);
    return [...selected, ...others];
  });
  private readonly sessionStore = inject(SessionStore);
  protected readonly isOrderLocked = this.sessionStore.isOrderLocked;
  private readonly cartStore = inject(CartStore);
  private params = toSignal(this.route.paramMap);
  public selectedCategoryId = computed(() => {
    const id = this.params()?.get('category');
    return id ? Number(id) : 0;
  });

  constructor() {
    effect(() => {
      const id = this.selectedCategoryId();
      if (id) {
        this.store.allProducts(id);
      }
    });

    effect(() => {
      const categories = this.store.categories();
      if (categories.length > 0 && this.categories().length === 0) {
        this.store.toggleBackButton(false);
        this.router.navigate(['/standard/categories'], {replaceUrl: true});
      }
    });
  }

  ngOnInit(): void {


    setTimeout(() => {

      this.store.setHeaderVisibility(true);
      this.store.toggleBackButton(true);
      this.store.setHeaderTitle(this.store.categoryName());
      this.store.setBackRoute('/standard/categories');
    });
  }

  viewDetail(item: FoodItem) {
    this.store.findProduct(item.productId);
    this.router.navigate(['/', 'standard', 'product', item.productId]);
  }


  addToCart(item: FoodItem, event?: Event) {
    if (event) event.stopPropagation();
    this.cartStore.addToCart(item);

    this.snackBar.open(`${item.name} añadido`, 'OK', {
      duration: 2000, horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['success-snackbar']
    });
  }


  protected goBack() {
    this.router.navigate(['/standard/categories'], {replaceUrl: true});
  }
}
